import { useEffect, useState } from "react";
import logo from "../img/logo.png";
import { IoMdMenu } from "react-icons/io";
import { IoClose } from "react-icons/io5";
import Pagetransition from "../pagetransition";
import { Link } from "react-scroll";
export default function Header() {
  const [right, setright] = useState("-750px");
  const [bg, setbg] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      window.scrollY > 400 ? setbg(true) : setbg(false);
    });
  }, []);
  return (
    <header name="Home">
      <nav className={bg ? "bg" : ""}>
        <div
          style={{
            width: "95%",
            margin: "auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className="logo">
            <img src={logo} alt="" srcset="" />
            <span>Estate</span>
          </div>
          <div
            className="nav-links"
            style={{
              right: `${right}`,
            }}
          >
            <div
              className="close-menu"
              onClick={() => {
                setright("-750px");
              }}
            >
              <IoClose />
            </div>
            <ul>
              <a href="/">
                <Link
                  to="Home"
                  smooth={true}
                  duration={500}
                  onClick={() => {
                    setright("-750px");
                  }}
                >
                  Home
                </Link>
              </a>
              <a href="/">
                <Link
                  to="About"
                  smooth={true}
                  duration={500}
                  onClick={() => {
                    setright("-750px");
                  }}
                >
                  About
                </Link>
              </a>
              <a href="/">
                <Link
                  to="Projects"
                  smooth={true}
                  duration={500}
                  onClick={() => {
                    setright("-750px");
                  }}
                >
                  Projects
                </Link>
              </a>
              <a href="/">
                <Link
                  to="Testimonials"
                  smooth={true}
                  duration={500}
                  onClick={() => {
                    setright("-750px");
                  }}
                >
                  Testimonials
                </Link>
              </a>
              <a href="/">
                <Link
                  to="Contact"
                  smooth={true}
                  duration={500}
                  onClick={() => {
                    setright("-750px");
                  }}
                >
                  Contact
                </Link>
              </a>
            </ul>
          </div>

          <div
            className="menu"
            onClick={() => {
              setright("0px");
            }}
          >
            <IoMdMenu />
          </div>
        </div>
      </nav>
      <Pagetransition>
        <div className="container">
          <div className="content">
            <h1> Explore homes that fit your dreams </h1>
            <div className="btn">
              <button className="bg-tr">Project</button>
              <button className="bg">Contact us</button>
            </div>
          </div>
        </div>
      </Pagetransition>
    </header>
  );
}
